import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false);  // 禁止凍結
export const popPaperSlice = createSlice({
  name: 'popPaper',
  initialState: {
    id: null
  },
  reducers: {
    popPaperUpdate: (state, action) => {
      return action.payload;
    },
  },
});
export const popPaperSelect = (state) => state.popPaper;
export const { popPaperUpdate } = popPaperSlice.actions;
export default popPaperSlice.reducer;